import React from "react";
import { PageHeader } from "./PageHeader";
import BookOfAbstracts from "../img/book.png";

export const ProgramBook = props => {
  return (
    <React.Fragment>
      <PageHeader title="Książka streszczeń" />
      <div className="content-wrapper">
        <div className="main-content book">
            <div>
            <img src={BookOfAbstracts} className="img-responsive mypic" alt="Książka streszczeń"/>
            </div>
            <div className="book-info">
                Książka streszczeń została przygotowana w formacie PDF do pobrania poniżej.
                <br/>
                Najnowsza wersja książki z dnia 02.09.2019 r. - rozmiar <b>18 MB</b>.
                <div className="text-center mt-2">
                    <a className="btn btn-primary" target="_blank" rel="noopener noreferrer" href="http://www.45zfp.uj.edu.pl/KsiazkaStreszczen.pdf">POBIERZ</a>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ProgramBook.propTypes = {};
